/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        listItem: {
            padding: {
                value: "8px",
                type: "dimension",
            },
            gap: {
                value: "8px",
                type: "dimension",
            },
            color: {
                value: "#1e1e1e",
                type: "color",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            borderColor: {
                value: "#e6e6e6",
                type: "color",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1.25rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            hover: {
                backgroundColor: {
                    value: "#EBEEF2",
                    type: "color",
                },
            },
            focus: {
                borderWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderColor: {
                    value: "#1e1e1e",
                    type: "color",
                },
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
            },
            bordered: {
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
            },
            media: {
                paddingLeft: {
                    value: "0",
                    type: "dimension",
                },
                paddingTop: {
                    value: "0",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "0",
                    type: "dimension",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
            },
            text: {
                paddingVertical: {
                    value: "2px",
                    type: "dimension",
                },
            },
            title: {
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
            },
            description: {
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
            },
            icon: {
                width: {
                    value: "24px",
                    type: "dimension",
                },
                height: {
                    value: "24px",
                    type: "dimension",
                },
            },
            sectionHeader: {
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                borderTopWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderTopColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
